(() => {
  if (window.ruvBabylistInitialized) return;
  window.ruvBabylistInitialized = true;
  const productData = new WeakMap();

  function refresh(wrapper) {
    const link = wrapper.querySelector('.ruv-babylist-btn');
    if (!link) return false;
    try {
      let product = productData.get(wrapper);
      if (!product) {
        product = JSON.parse(wrapper.querySelector('[data-babylist-product]').textContent);
        productData.set(wrapper, product);
      }
      const form = document.getElementById(`product-form-${wrapper.dataset.sectionId}`);
      const section = document.getElementById(`MainProduct-${wrapper.dataset.sectionId}`);
      const picker = section?.querySelector('variant-selects, variant-radios');
      const selectedId = form?.querySelector('input[name="id"]')?.value || product.selectedVariantId;
      const variant = product.variants.find(item => String(item.id) === String(selectedId));
      const invalidSelection = picker && Object.prototype.hasOwnProperty.call(picker, 'currentVariant') && !picker.currentVariant;
      if (!variant || invalidSelection) {
        link.removeAttribute('href');
        link.setAttribute('aria-disabled', 'true');
        return false;
      }
      const productUrl = new URL(product.url);
      productUrl.searchParams.set('variant', variant.id);
      const title = variant.title && variant.title !== 'Default Title'
        ? `${product.title} - ${variant.title}` : product.title;
      const selectedImage = variant.featured_image?.src || variant.featured_media?.preview_image?.src || product.image;
      const imageUrl = new URL(selectedImage, product.url).href;
      const addUrl = new URL('https://www.babylist.com/bookmarklet/');
      addUrl.searchParams.set('popup', 'true');
      addUrl.searchParams.set('url', productUrl.href);
      addUrl.searchParams.set('title', title);
      addUrl.searchParams.set('imgs[]', imageUrl);
      addUrl.searchParams.set('price', (variant.price / 100).toFixed(2));
      link.href = addUrl.href;
      link.setAttribute('aria-label', `Add ${title} to your Babylist registry`);
      link.removeAttribute('aria-disabled');
      return true;
    } catch (error) {
      // The server-rendered, variant-specific link remains usable if data is unavailable.
      return link.hasAttribute('href');
    }
  }

  function initialize(root = document) {
    root.querySelectorAll('[data-ruv-babylist]').forEach(refresh);
  }

  document.addEventListener('change', event => {
    const section = event.target.closest('section[id^="MainProduct-"]');
    if (section) initialize(section);
  });
  for (const eventName of ['pointerdown', 'focusin', 'click']) {
    document.addEventListener(eventName, event => {
      const link = event.target.closest('.ruv-babylist-btn');
      const wrapper = link?.closest('[data-ruv-babylist]');
      if (wrapper && !refresh(wrapper) && eventName === 'click') event.preventDefault();
    });
  }
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  initialize();
})();
